import AppModal from "../appModal/AppModal";

/**
 * @param {React Component} children Anything that could be used in between opening and closing tags
 * @param {boolean} open
 *          => if true it displays the modal
 *          => if false the modal won't be displayed
 * @param {function} setOpen the setOpen which will be used to close the modal
 *
 * @returns {React Component} Error App Modal
 */

/**
 * Sample Code
 * 
 *  const [open, setOpen] = useState(false);
 * 
 *  <ErrorModal open={open} setOpen={setOpen}>
 *      Hello this is an Error Message
 *  </ErrorModal>
 *  
 *  <button onClick={() => setOpen(true)}>
 *      Click to See ERROR Modal
 *  </button>
                        
 */

const ErrorModal = ({ children, open, setOpen }) => {
    const handleClose = () => setOpen(false);

    return (
        <AppModal
            config={{
                type: "error",
                open,
                handleClose,
                buttons: {
                    actionButton: {
                        text: "Close",
                        actionFunction: handleClose,
                        secondaryButton: false,
                    },
                },
            }}
        >
            {children}
        </AppModal>
    );
};

export default ErrorModal;
